import { NavLink } from "react-router-dom";
import Logo from "../../../shared/design/Logo";

type Props = {
  /** "full" = 4-column footer (marketing pages); "condensed" = single row (Contact, Account) */
  variant?: "full" | "condensed";
};

const footerLinkClass =
  "text-[14px] text-muted-300 no-underline transition-colors hover:text-sand";

const Footer = ({ variant = "full" }: Props) => {
  if (variant === "condensed") {
    return (
      <footer className="bg-ink px-6 py-10 text-muted-300 md:px-12">
        <div className="mx-auto flex max-w-[1320px] flex-wrap items-center justify-between gap-3.5">
          <Logo tone="light" />
          <div className="font-mono text-[12.5px] text-muted-400">
            © 2026 WANDER NA · PRIVACY · TERMS
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-ink px-6 pb-8 pt-14 text-muted-300 md:px-12">
      <div className="mx-auto max-w-[1320px]">
        <div className="grid grid-cols-1 gap-8 border-b border-white/10 pb-10 md:grid-cols-[1.6fr_1fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <Logo tone="light" className="mb-4" />
            <p className="max-w-[280px] text-[14px] leading-relaxed text-muted-300">
              Guided expeditions through the wildest corners of North America
              since 2016.
            </p>
          </div>

          {/* Explore */}
          <div>
            <div className="mb-3.5 text-[13px] font-bold text-white">
              Explore
            </div>
            <div className="flex flex-col gap-2.5">
              <NavLink to="/tours" className={footerLinkClass}>
                All tours
              </NavLink>
              <NavLink to="/tours" className={footerLinkClass}>
                Destinations
              </NavLink>
              <NavLink to="/people" className={footerLinkClass}>
                Our team
              </NavLink>
            </div>
          </div>

          {/* Company */}
          <div>
            <div className="mb-3.5 text-[13px] font-bold text-white">
              Company
            </div>
            <div className="flex flex-col gap-2.5">
              <NavLink to="/" className={footerLinkClass}>
                About
              </NavLink>
              <NavLink to="/careers" className={footerLinkClass}>
                Careers
              </NavLink>
              <NavLink to="/contact" className={footerLinkClass}>
                Contact
              </NavLink>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <div className="mb-3.5 text-[13px] font-bold text-white">
              Get the dispatch
            </div>
            <p className="mb-3 text-[13.5px] text-muted-300">
              Trail notes &amp; new trips, monthly.
            </p>
            <div className="flex rounded-full bg-white/10 py-[5px] pl-4 pr-[5px]">
              <input
                placeholder="Email"
                aria-label="Email"
                className="min-w-0 flex-1 border-none bg-transparent text-[13px] text-white outline-none placeholder:text-muted-300"
              />
              <button className="cursor-pointer rounded-full border-none bg-primary-500 px-4 py-2 text-[13px] font-bold text-ink">
                Join
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-between gap-2 pt-5 font-mono text-[12.5px] text-muted-400">
          <span>© 2026 WANDER NA</span>
          <span>PRIVACY · TERMS · ⌖ 49.1°N 113.9°W</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
